import React from 'react';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';
import { useBreadcrumbs } from '../components/breadcrumbs/BreadcrumbContext';
import Stedi_COB_Testing from '../components/Stedi_COB_Testing';

const TestingStedi_COB: React.FC = () => {
  const navigate = useNavigate();
  useBreadcrumbs([{ label: 'Stedi COB' }]);

  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4'>
          <Button
            variant='outline'
            onClick={() => navigate('/testing')}
            className='flex items-center space-x-2'
          >
            <span>←</span>
            <span>Back to Testing</span>
          </Button>
        </div>
      </div>

      <Stedi_COB_Testing />
    </div>
  );
};

export default TestingStedi_COB;
